
<div class="flex flex-col gap-4">
  <span class="font-medium text-[1.125rem] leading-[1.6875rem] font-sans">Share this article</span>
  <div class="flex flex-wrap gap-2">
    <button
      title="Copy link"
      class="share-button relative"
      @click="copyLinkToClipboard"
    >
      <img src="@/images/link.svg" alt="Copy link">
      <span v-if="showCopiedLinkPopup"
        class="z-20 absolute bottom-[calc(100%+0.5rem)] left-1/2 -translate-x-1/2 rounded-md text-[0.625rem] leading-none bg-[#EDE9E3] px-2 py-1"
      >
        Copied!
        <div class="arrow-down absolute top-full left-1/2 -translate-x-1/2"></div>
      </span>
    </button>
    <a
      :href="linkedinUrl"
      target="_blank"
      class="share-button"
    >
      <img src="@/images/social-media/linkedin-solid.svg" alt="linkedin">
    </a>
    <a
      :href="twitterUrl"
      target="_blank"
      class="share-button"
    >
      <img src="@/images/social-media/X.svg" alt="twitter">
    </a>
    <a
      :href="facebookUrl"
      target="_blank"
      class="share-button"
    >
      <img src="@/images/social-media/facebook-rounded.svg" alt="Facebook">
    </a>
  </div>
</div>
